export default __webpack_public_path__ + "static/1-f3490521e66a275320d611cdca08dd7d.jpeg";